import { Battery, Brain, Activity, Leaf } from "lucide-react";

const features = [
  {
    icon: Battery,
    title: "Clean Energy",
    description: "No crash.\nNo jitters.",
  },
  {
    icon: Brain,
    title: "Mental Focus",
    description: "Stay sharp.\nStay in control.",
  },
  {
    icon: Activity,
    title: "Performance",
    description: "For workouts,\nwork & everything\nin between.",
  },
  {
    icon: Leaf,
    title: "Natural & Pure",
    description: "No artificial\nsweeteners,\nflavors or colors.",
  },
];

const FeaturesSection = () => {
  return (
    <section className="py-20 sm:py-28">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <h2 className="section-heading">
            Why Solr<span className="text-[hsl(var(--magenta-glow))]">?</span>
          </h2>
          <p className="text-white/70 mt-4 max-w-xl mx-auto">
            Clean energy. Real ingredients. Real benefits — backed by nature, perfected by science.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 lg:gap-8">
          {features.map((f, i) => (
            <div key={i} className="flex flex-col items-center text-center group">
              <div className="relative mb-5">
                <div className="absolute inset-0 -z-10 blur-2xl opacity-60 bg-[hsl(var(--magenta)/0.4)] rounded-full" />
                <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full border-2 border-[hsl(var(--magenta)/0.5)] flex items-center justify-center bg-[hsl(var(--cosmic-mid))] group-hover:border-[hsl(var(--magenta))] group-hover:shadow-[0_0_30px_hsl(var(--magenta)/0.4)] transition-all">
                  <f.icon className="w-8 h-8 text-[hsl(var(--magenta-glow))]" strokeWidth={1.5} />
                </div>
              </div>
              <h3 className="font-display uppercase tracking-[0.12em] text-white text-base sm:text-lg mb-2">
                {f.title}
              </h3>
              <p className="text-sm text-white/65 whitespace-pre-line leading-relaxed">
                {f.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
